export default __webpack_public_path__ + "static/media/Opportunities.e778bf4f.svg";